/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Online_About_TitleInputs */

const en_pc_online_about_title = /** @type {(inputs: Pc_Online_About_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What PdfCraft Online is`)
};

const zh_pc_online_about_title = /** @type {(inputs: Pc_Online_About_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PdfCraft 在线版是什么`)
};

/**
* | output |
* | --- |
* | "What PdfCraft Online is" |
*
* @param {Pc_Online_About_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_online_about_title = /** @type {((inputs?: Pc_Online_About_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Online_About_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_online_about_title(inputs)
	return zh_pc_online_about_title(inputs)
});
export { pc_online_about_title as "pc.online.about_title" }